<template>
  <q-page class="q-px-md">
    <div
      v-if="loadingAudits"
      class="fullscreen column flex-center z-max text-center"
    >
      <h5>
        {{ $t('audit.loadingAudit') }}
        <q-spinner-dots class="sw-c-loader" size="50px" />
      </h5>
    </div>
    <div v-else>
      <h5
        v-if="!zones.length"
        class="text-center absolute-center full-width text-grey-7 q-pb-xl"
      >
        {{ $t('audit.auditFinish') }} <br />{{ $t('audit.goodJob') }}
      </h5>
      <div v-else v-for="zone in zones" :key="zone.id">
        <div
          class="row q-py-md"
          :key="zone.id"
          @click="$router.push(`/zones/${zone.id}`)"
        >
          <div class="col-xs-2 col-sm-3 col-md-4 col-lg-5">
            <q-btn
              round
              color="primary"
              size="15px"
              :key="'btn' + zone.id"
              class="float-right"
            >
              <q-icon name="location_city" size="30px" />
            </q-btn>
          </div>
          <div class="col-xs-10 col-sm-9 col-md-8 col-lg-7 q-pl-sm">
            <span class="uppercase">{{ zone.name }} </span>
            <span class="q-caption">
              <br /><i>( {{ displayNbControls(zone.auditsCount) }})</i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </q-page>
</template>
<script>
export default {
  name: 'AuditsList',
  props: {
    zones: Array,
    loadingAudits: Boolean
  },
  data() {
    return {}
  },
  methods: {
    displayNbControls(count) {
      return count > 1
        ? count + ` ${this.$t('navigation.audits')}`
        : count + ` ${this.$t('common.audit')}`
    }
  }
}
</script>
<style scoped>
main {
  min-height: unset !important;
}
</style>
